<template>
    <div>
        <div class="mask" v-show="dateboxshow || timepickershow"></div>

        <div class="isloginTips" v-show="loadingShow">
            <img src="@/assets/loading.png" alt="">
            <p>提交中...</p>
        </div>

        <div class="timebox" v-show="timepickershow">
            <div class="timeboxwrapper">
                <div class="title">选择挂单有效期</div>
                <ul>
                    <li>年</li>
                    <li>月</li>
                    <li>日</li>
                    <li>时</li>
                    <li>分</li>
                </ul>
                <van-datetime-picker v-model="currentDate" type="datetime" :min-date="minDate" :max-date="maxDate" @change="onchange" visible-item-count="3" :show-toolbar="false"/>
            </div>
            <div class="timebtn">
                <p @click="confirmremove">取消</p>
                <p @click="confirmPicker">确定</p>
            </div>
        </div>

        <div class="revise">
            <div class="title">
                <img @click="handleBack" src="@/assets/back.png" alt="">
                <p>修改挂单</p>
                <p v-preventReClick @click="handleorder">撤单</p>
            </div>
            <div class="list-item" style="background-color:#F5F5F5">
                <div class="title">
                    <span :style="{backgroundColor:this.$store.state.orderDirection == 2 || this.$store.state.orderDirection == 6?'#FF4F36':(this.$store.state.orderDirection == 3 || this.$store.state.orderDirection == 7?'#17CF84':(this.$store.state.orderDirection == 4?'#FF4F36':(this.$store.state.orderDirection == 5?'#17CF84':'#999999')))}">{{this.$store.state.orderDirection == 2?'限价买入':(this.$store.state.orderDirection == 3?'限价卖出':(this.$store.state.orderDirection == 4?'止损买入':(this.$store.state.orderDirection == 5?'止损卖出':(this.$store.state.orderDirection == 6?'停损限价买入':(this.$store.state.orderDirection == 7?'停损限价卖出':(this.$store.state.orderDirection == 0?'买入':(this.$store.state.orderDirection == 1?'卖出':'')))))))}}</span>
                    <span>{{this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD'?'伦敦金':(this.$store.state.symbol == 'XAG' || this.$store.state.symbol == 'SILVER'?'伦敦银':'美元')}} {{this.$store.state.lots.toFixed(2)}}手</span>
                    <span class="time">{{getTime(this.$store.state.openTime)}}</span>
                </div>
                <ul>
                    <li>
                        <div class="left">
                            <p>订单号<span>{{this.$store.state.ticket}}</span></p>
                            <p>挂单价<span>{{this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD'?parseFloat(this.$store.state.openPrice).toFixed(2):(this.$store.state.symbol == 'XAG' || this.$store.state.symbol == 'SILVER'?parseFloat(this.$store.state.openPrice).toFixed(3):'未知')}}</span></p>
                            <p>最新价<span>{{newprice}}</span></p>
                            <p v-show="this.$store.state.mt == 5 && Number(this.$store.state.stopLimit)">停损限价<span>{{this.$store.state.stopLimit}}</span></p>
                        </div>
                        <div class="right">
                            <p>有效期<span>{{this.$store.state.expiration == 0?'长期有效':getTime(this.$store.state.expiration)}}</span></p>
                            <p>止损价<span>{{this.$store.state.stopLoss == '0.00' || this.$store.state.stopLoss == '0.000' ?'未设置':this.$store.state.stopLoss}}</span></p>
                            <p>止盈价<span>{{this.$store.state.takeProfit == '0.00' || this.$store.state.takeProfit == '0.000' ?'未设置':this.$store.state.takeProfit}}</span></p>
                            <!-- <p>止损价<span>{{this.$store.state.stopLoss!==0 && (this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD')?parseFloat(this.$store.state.stopLoss).toFixed(2):(this.$store.state.stopLoss!==0 && (this.$store.state.symbol == 'XAG' || this.$store.state.symbol == 'SILVER')?parseFloat(this.$store.state.stopLoss).toFixed(3):'未设置')}}</span></p>
                            <p>止盈价<span>{{this.$store.state.takeProfit!==0 && (this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD')?parseFloat(this.$store.state.takeProfit).toFixed(2):(this.$store.state.takeProfit!==0 && (this.$store.state.symbol == 'XAG' || this.$store.state.symbol == 'SILVER')?parseFloat(this.$store.state.takeProfit).toFixed(3):'未设置')}}</span></p> -->
                        </div>
                    </li>
                </ul>

            </div>

            <div class="revise-content">
                <div class="tips">挂单价格至少远离最新价{{this.$store.state.symbol == "XAU" || this.$store.state.symbol == "GOLD"?this.$store.state.goldstopsLevel:this.$store.state.silverstopsLevel}}点。</div>
                <div class="revise-item">
                    <p>有效期</p>
                    <p v-if="!datetext" @click="handledates">{{this.$store.state.expiration == 0?'长期有效':getTime(this.$store.state.expiration)}}<span><img class="icon-right" src="@/assets/icon-right.png" alt=""></span></p>
                    <p v-else @click="handledates">{{datetext}}<span><img class="icon-right" src="@/assets/icon-right.png" alt=""></span></p>
                </div>
                <div class="revise-item">
                    <p>挂单价格<span>{{gdprice?gdprice:this.$store.state.news}}</span></p>
                    <p>
                        <img @click="goldgdcut" src="@/assets/cut.png" alt="" class="cut">
                        <input type="num" placeholder="价格" v-model="reviseNum" @input="ongoldprice">
                        <img @click="goldgdadd" src="@/assets/add.png" alt="" class="add">
                        <span style="padding-left:5px;" @click="removereviseNum">清空</span>
                    </p>
                </div>

                <div class="revise-item" v-show="this.$store.state.mt == 5 && Number(this.$store.state.stopLimit)">
                    <p>停损限价<span>{{tsprice}}</span></p>
                    <p>
                        <img @click="tscut" src="@/assets/cut.png" alt="" class="cut">
                        <input type="num" placeholder="价格" v-model="tsnum" @input="ontsprice">
                        <img @click="tsadd" src="@/assets/add.png" alt="" class="add">
                        <span style="padding-left:5px;" @click="tsreset">清空</span>
                    </p>
                </div>

                <div class="revise-item" style="border:none;">
                    <p style="color:#999999">止盈止损设置</p>
                    <p>
                        <i style="display:flex;font-style:normal;border:1px solid #FFEDEA;border-radius:11px">
                        <span :class="jiage?'active':'actived'" style="border-right-top-radius:0;border-right-bottom-radius:0;" class="jiage" @click="jg">价格</span>
                        <span :class="ds?'active':'actived'" class="dianshu" @click="handleds">点数</span>
                        </i>
                        <img class="price-up" @click="changeicon" :style="{transform: !this.slideshow ? 'rotate(180deg)' : 'rotate(0deg)'}" src="@/assets/price-up.png" alt="">
                    </p>
                </div>

                <div v-show="slideshow">
                    <div class="slider-down" v-show="slideshow && jiage">
                        <div class="sliderdown-item">
                            <p>止损价
                                <span v-show="getisgold">{{reviseNum && !zhisun?gdzhisun:(reviseNum && zhisun?comtotalzhisun:'')}}</span>
                                <span v-show="!getisgold">{{reviseNum && !zhisun?slgdzhisun:(reviseNum && zhisun?slcomtotalzhisun:'')}}</span>
                            </p>
                            <p>
                                <img @click="zhisuncut" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhisun" @input="onzhisun">
                                <img @click="zhisunadd" src="@/assets/add.png" alt="" class="add">
                                <span @click="removezhisun">清空</span>
                            </p>
                        </div>
                        <div class="sliderdown-item">
                            <p>止盈价
                                <span v-show="getisgold">{{reviseNum && !zhiying?gdzhiying:(reviseNum && zhiying?comtotalzhiying:'')}}</span>
                                <span v-show="!getisgold">{{reviseNum && !zhiying?slgdzhiying:(reviseNum && zhiying?slcomtotalzhiying:'')}}</span>
                            </p>
                            <p>
                                <img @click="zhiyingcut" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhiying" @input="onzhiying">
                                <img @click="zhiyingadd" src="@/assets/add.png" alt="" class="add">
                                <span @click="removezhiying">清空</span>
                            </p>
                        </div>
                    </div>

                    <div class="slider-down" v-show="slideshow && ds">
                        <div class="sliderdown-item">
                            <p>止损
                                <span>{{zhisundianshu?getdszhisun:'>200'}}</span>
                            </p>
                            <p>
                                <img @click="zhisundscut" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhisundianshu" @input="onzhisunds">
                                <img @click='zhisundsadd' src="@/assets/add.png" alt="" class="add">
                                <span @click="removedianshuzhisun">清空</span>
                            </p>
                        </div>
                        <div class="sliderdown-item">
                            <p>止盈
                                <span>{{zhiyingdianshu?getdszhiying:'>200'}}</span>
                            </p>
                            <p>
                                <img @click="zhiyingdscut" src="@/assets/cut.png" alt="" class="cut">
                                <input type="num" placeholder="未设置" v-model="zhiyingdianshu" @input="onzhiyingds">
                                <img @click="zhiyingdsadd" src="@/assets/add.png" alt="" class="add">
                                <span @click="removedianshuzhiying">清空</span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="reviseBtn">
                    <p @click="handleBack">取消修改</p>
                    <p v-preventReClick @click="confirmRevise">确认修改</p>
                </div>

            </div>

        </div>

        <!-- 交易日期弹出框 -->
        <div class="databox" v-show="dateboxshow">
            <div class="title">选择挂单有效期 <img class="close" @click="handleClose" src="@/assets/close.png" alt=""></div>
            <div class="datelist">
                <div v-for="(item,index) in datelist" :key="index" class="item" @click="handledate(index)">{{item.title}}<img v-show="dateselectIndex==index?true:false" src="@/assets/correct.png" alt=""></div>
            </div>
        </div>
        
    </div>
</template>

<script>
import pako from 'pako'
import {reviseOrder,utf8ByteToUnicodeStr,handleChedan} from '@/utils/socket2.js';
import {mapState,mapMutations,mapAction,mapGetters} from 'vuex'
import {toFixed2} from '@/utils/tofixed'
import moment from 'moment'
import { Message } from 'element-ui';
export default {
    name:'revisepages',
    props:{

    },
    data(){
        return{
            loadingShow:false,
            minDate: new Date(2020, 0, 1),
            maxDate: new Date(2025, 10, 1),
            currentDate: new Date(),
            timepickershow:false,
            changetime:null,

            reviseNum:null,//挂单价格

            confirmBtn:false,//确认时间开关

            Chedan:false,//是否撤单
            reviseShow:true,//撤单页面显示隐藏
            slideshow:true,
            jiage:true,
            ds:false,

            orderDirection:null,
            openPrice:null,
            symbol:null,
            ticket:null,
            openTime:null,
            lots:null,
            expiration:null,
            stopLoss:null,
            takeProfit:null,
            news:null,
            stopsLevel:null,//挂单距离
            gdprice:null,//挂单价格
            gdzhisun:null,//黄金挂单计算的止损
            gdzhiying:null,//黄金挂单计算的止盈
            slgdzhisun:null,//白银挂单计算的止损
            slgdzhiying:null,//白银挂单计算的止盈
            zhisundianshu:null,//止损点数
            zhiyingdianshu:null,//止盈点数
            goldpriceflag:false,//挂单价格开关
            gdclicktotal:0,//挂单点击总次数
            clicktotal:0,
            clicktotals:0,

            changeorder:false,//是否改变订单

            silverflag:true,
            goldflag:true,

            dsflag:true,
            dssilverflag:true,

            dsflags:true,
            dssilverflags:true,

            dsclicktotal:0,
            dsclicktotals:0,
            dsslclicktotal:0,
            dsslclicktotals:0,
            tsprice:null,//停损限价
            tsnum:this.$store.state.stopLimit,//停损限价输入框价格
            tsclick:0,//停损限价点击

            getisgold:false,

            silverclicktotal:0,
            silverclicktotals:0,

            changgezhisun:null,//止损点数转换为止损价
            changgezhiying:null,//止盈点数转换为止盈价

            zhisun:null,//input里的止损
            zhiying:null,//input里的止盈

            dateselectIndex:0, //交易类型选择
            dateboxshow:false, //选择交易类型弹框
            datelist:[{'id':'0','title':'长期有效'},{'id':'1','title':'本日有效'},{'id':'2','title':'本周有效'},{'id':'3','title':'本月有效'},{'id':'4','title':'自定义'}],
            datetext:null
        }
    },
    methods:{

        // reviseNum 加减
        goldgdadd(){
            if(this.getisgold){
                var initnum = 0.01
                this.gdclicktotal++
                this.reviseNum = this.NumberAdd(this.reviseNum,initnum)
            }else if(!this.getisgold){
                var initnum = 0.001
                this.gdclicktotal++
                this.reviseNum = this.NumberAdd(this.reviseNum,initnum)
            }
        },

        goldgdcut(){
            if(this.getisgold){
                var initnum = 0.01
                if(this.reviseNum<=0)return false
                this.gdclicktotal++
                this.reviseNum = this.Sub(this.reviseNum,initnum)
            }else if(!this.getisgold){
                var initnum = 0.001
                if(this.reviseNum<=0)return false
                this.gdclicktotal++
                this.reviseNum = this.Sub(this.reviseNum,initnum)
            }
        },

        removereviseNum(){
            this.reviseNum = null
            this.gdclicktotal = 0
            this.goldpriceflag = true
        },


        tsadd(){
            if(this.getisgold){
                var initnum = 0.01
                this.tsclick++
                this.tsnum = this.NumberAdd(this.tsnum,initnum)
            }else if(!this.getisgold){
                var initnum = 0.001
                this.tsclick++
                this.tsnum = this.NumberAdd(this.tsnum,initnum)
            }
        },

        tscut(){
            if(this.getisgold){
                var initnum = 0.01
                if(this.tsnum<=0)return false
                this.tsclick++
                this.tsnum = this.Sub(this.tsnum,initnum)
            }else if(!this.getisgold){
                var initnum = 0.001
                if(this.tsnum<=0)return false
                this.tsclick++
                this.tsnum = this.Sub(this.tsnum,initnum)
            }
        },

        tsreset(){
            this.tsnum = null
            this.tsclick = 0
        },


    // 止损
        zhisunadd(){

            // 黄金止损加
            if(this.getisgold){

                var initnum = 0.01

                if(this.clicktotal == 0 && this.goldflag){

                    if(this.$store.state.orderDirection == 2){
                        this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 3){
                        this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 4){
                        this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 5){
                        this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 6){
                        this.zhisun = (this.Sub(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 7){
                        this.zhisun = (this.NumberAdd(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                    }

                }
                this.clicktotal++
                this.zhisun = this.NumberAdd(this.zhisun,initnum)

            }
            // 白银止损加            
            if(!this.getisgold){
                var initnum = 0.001
                if(this.silverclicktotal == 0 && this.silverflag){

                        if(this.$store.state.orderDirection == 2){
                            this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 3){
                            this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 4){
                            this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 5){
                            this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 6){
                            this.zhisun = (this.Sub(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 7){
                            this.zhisun = (this.NumberAdd(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }

                }
                this.silverclicktotal++
                this.zhisun = this.NumberAdd(this.zhisun,initnum)

            }
        },
    // 止损
        zhisuncut(){

            // 黄金止损减
            if(this.getisgold){
                var initnum = 0.01
                if(this.clicktotal == 0 && this.goldflag){

                    if(this.$store.state.orderDirection == 2){
                        this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 3){
                        this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 4){
                        this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 5){
                        this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 6){
                        this.zhisun = (this.Sub(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                    }else if(this.$store.state.orderDirection == 7){
                        this.zhisun = (this.NumberAdd(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                    }

                }
                this.clicktotal++
                if(this.zhisun <= 0)return false
                this.zhisun = this.Sub(this.zhisun,initnum)

            }
            // 白银止损减
            if(!this.getisgold){
                var initnum = 0.001
                if(this.silverclicktotal == 0 && this.silverflag){

                        if(this.$store.state.orderDirection == 2){
                            this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 3){
                            this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 4){
                            this.zhisun = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 5){
                            this.zhisun = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 6){
                            this.zhisun = (this.Sub(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 7){
                            this.zhisun = (this.NumberAdd(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }
                }
                this.silverclicktotal++
                if(this.zhisun <= 0)return false
                this.zhisun = this.Sub(this.zhisun,initnum)

            }

        },

    // 止盈
        zhiyingadd(){

            // 黄金止盈加
            if(this.getisgold){
                var initnum = 0.01
                if(this.clicktotals == 0 && this.goldflag){

                        if(this.$store.state.orderDirection == 2){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 3){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 4){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 5){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 6){
                            this.zhiying = (this.NumberAdd(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 7){
                            this.zhiying = (this.Sub(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                        }

                }
                this.clicktotals++
                this.zhiying = this.NumberAdd(this.zhiying,initnum)
            }
            
            // 白银止盈加
            if(!this.getisgold){
                var initnum = 0.001
                if(this.silverclicktotals == 0 && this.silverflag){

                    if(this.$store.state.orderDirection == 2){
                        this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                    }else if(this.$store.state.orderDirection == 3){
                        this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                    }else if(this.$store.state.orderDirection == 4){
                        this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                    }else if(this.$store.state.orderDirection == 5){
                        this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                    }else if(this.$store.state.orderDirection == 6){
                        this.zhiying = (this.NumberAdd(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                    }else if(this.$store.state.orderDirection == 7){
                        this.zhiying = (this.Sub(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                    }

                }
                this.silverclicktotals++
                this.zhiying = this.NumberAdd(this.zhiying,initnum)
            }
        },
    
    // 止盈
        zhiyingcut(){
            // 黄金止盈减
            if(this.getisgold){
                var initnum = 0.01
                if(this.clicktotals == 0 && this.goldflag){
                        if(this.$store.state.orderDirection == 2){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 3){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 4){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 5){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 6){
                            this.zhiying = (this.NumberAdd(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                        }else if(this.$store.state.orderDirection == 7){
                            this.zhiying = (this.Sub(this.tsnum,(this.$store.state.goldstopsLevel * 0.01)))
                        }

                }
                this.clicktotals++
                if(this.zhiying <= 0)return false
                this.zhiying = this.Sub(this.zhiying,initnum)
            }
            // 白银止盈减
            if(!this.getisgold){
                var initnum = 0.001
                if(this.silverclicktotals == 0 && this.silverflag){

                        if(this.$store.state.orderDirection == 2){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 3){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 4){
                            this.zhiying = (this.NumberAdd(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 5){
                            this.zhiying = (this.Sub(this.reviseNum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 6){
                            this.zhiying = (this.NumberAdd(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }else if(this.$store.state.orderDirection == 7){
                            this.zhiying = (this.Sub(this.tsnum,(this.$store.state.silverstopsLevel * 0.001)))
                        }

                }
                this.silverclicktotals++
                if(this.zhiying <= 0)return false
                this.zhiying = this.Sub(this.zhiying,initnum)
            }

        },

        // 清空止损价
        removezhisun(){
            if(this.getisgold){
                this.zhisun = null
                this.clicktotal = 0
            }else if(!this.getisgold){
                this.zhisun = null
                this.silverclicktotal = 0
            }
        },

        // 清空止盈价
        removezhiying(){
            if(this.getisgold){
                this.zhiying = null
                this.clicktotals = 0
            }else if(!this.getisgold){
                this.zhiying = null
                this.silverclicktotals = 0
            }
        },

        // 止损点数加
        zhisundsadd(){
            var initnum = 1
            if(this.dsclicktotal == 0 && this.dsflag){
                this.zhisundianshu = 199
            }
            this.dsclicktotal++
            this.zhisundianshu = Number(this.NumberAdd(this.zhisundianshu,initnum))
        },

        // 止损点数减
        zhisundscut(){
            var initnum = 1
            if(this.dsclicktotal == 0 && this.dsflag){
                this.zhisundianshu = 201
            }
            // if(this.zhisundianshu <= 0) return false
            this.dsclicktotal++
            this.zhisundianshu = Number(this.Sub(this.zhisundianshu,initnum))
        },

        // 清空止损点数
        removedianshuzhisun(){
            this.zhisundianshu = null //清空点数
            this.changgezhisun = null //清空点数换算的价格

            this.dsclicktotal = 0
        },

        // 止盈点数加
        zhiyingdsadd(){
            var initnum = 1
            if(this.dsclicktotals == 0 && this.dsflags){
                this.zhiyingdianshu = 199
            }
            this.dsclicktotals++
            this.zhiyingdianshu = Number(this.NumberAdd(this.zhiyingdianshu,initnum))
        },

        // 止损点数减
        zhiyingdscut(){
            var initnum = 1
            if(this.dsclicktotals == 0 && this.dsflags){
                this.zhiyingdianshu = 201
            }
            this.dsclicktotals++
            this.zhiyingdianshu = Number(this.Sub(this.zhiyingdianshu,initnum))
        },

        // 清空止盈点数
        removedianshuzhiying(){
            this.zhiyingdianshu = null //清空点数
            this.changgezhiying = null //清空点数换算的价格

            this.dsclicktotals = 0
        },

        NumberAdd(arg1, arg2){
            var r1,r2,m,n
            try{
                r1 = arg1.toString().split('.')[1].length
            } catch (e){
                r1 = 0
            }
            try{
                r2 = arg2.toString().split('.')[1].length
            } catch (e){
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2))
            n = ( r1 >= r2 ) ? r1 : r2
            return ((arg1 * m + arg2 * m ) / m ).toFixed(n)
        },

        Sub(arg1, arg2) {
            arg1 = parseFloat(arg1);
            arg2 = parseFloat(arg2);
            var r1, r2, m, n;
            try {
                r1 = arg1.toString().split(".")[1].length
            } catch (e) {
                r1 = 0
            }
            try {
                r2 = arg2.toString().split(".")[1].length
            } catch (e) {
                r2 = 0
            }
            m = Math.pow(10, Math.max(r1, r2));
            //动态控制精度长度
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m ) / m ).toFixed(n)
        },

        // 监听黄金页面挂单价格输入框
        ongoldprice(e) {

            if(this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.reviseNum = e.target.value
        },
        // 监听黄金页面挂单价格输入框

        ontsprice(e) {
            if(this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.tsnum = e.target.value
        },

        // 止损input
        onzhisun(e) {
            if(e.target.value == 0){
                this.$toast('不能输入0')
                this.zhisun = null
                return false;
            }
            if(this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.zhisun = e.target.value
        },

        // 止盈input
        onzhiying(e) {
            if(e.target.value == 0){
                this.$toast('不能输入0')
                this.zhiying = null
                return false;
            }
            if(this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,2})/g)[0]) || null
            }else if(!this.getisgold){
                e.target.value = (e.target.value.match(/^\d*(\.?\d{0,3})/g)[0]) || null
            }
            this.zhiying = e.target.value
        },
        
        onzhisunds(e){
            this.zhisundianshu = e.target.value
        },

        onzhiyingds(e){
            this.zhiyingdianshu = e.target.value
        },

        // 控制图标
        changeicon(){
            this.slideshow = !this.slideshow
        },

        // 控制图标
        jg(){
            this.ds = false
            this.jiage = true

            this.removedianshuzhisun() //每次切换清空
            this.removedianshuzhiying() //每次切换清空
            

        },
        
        // 控制图标
        handleds(){
            this.ds = true
            this.jiage = false

            this.removezhisun() //每次切换清空
            this.removezhiying() //每次切换清空

        },

        // 点击弹出交易日期弹框
        handledates(){
            this.dateboxshow = true
            
        },

        // 关闭交易类型、交易日期弹出框
        handleClose(){
            this.dateboxshow = false
        },

        // 选择交易日期
        handledate(index){
            this.dateselectIndex = index
            this.datetext = this.datelist[index].title
            this.dateboxshow = false
            if(index == 4){
                this.datetext = null
                this.timepickershow = true
            }
        },

        // 时间选定
        onchange(val){
            this.changetime = val.getValues()[0]+'-'+val.getValues()[1]+'-'+val.getValues()[2]+' '+val.getValues()[3]+':'+val.getValues()[4]
        },

        // 时间确认
        confirmPicker(){
            if(this.changetime){
                this.datetext = this.changetime
            }else{
                this.datetext = moment().format("YYYY-MM-DD HH:mm:ss"); //当前时间
            }

            this.timepickershow = false
        },

        // 时间取消
        confirmremove(){
            this.timepickershow = false
        },

        // 返回撤单页面
        handleBack(){

            this.$router.go(-1)
        },

        // 点击撤单
        handleorder(){
            var that = this
            that.global.ws.onmessage = this.onmessage
            that.Chedan = true
            if (that.global.ws && that.global.ws.readyState == 1 && that.Chedan) {
                handleChedan(that.$store.state.ticket,that.global.ws)
                that.loadingShow = true
            }
        },

        // 开启websocket
        initWebpack(){

            var that = this

            that.global.ws.onmessage = this.onmessage

        },

        onmessage(evt){
            var data = atob(evt.data);
            var data2 = pako.inflateRaw(data);
            var arr = new Uint16Array(data2);
            var strData   = utf8ByteToUnicodeStr(arr);
            var obj = JSON.parse(strData)



            if(obj.act == 'order_modify'){
                
                if(obj.success == true){

                    this.changeorder = false //订单修改开关关闭
                    this.zhisun = this.zhisun?this.zhisun:null //必须
                    this.zhiying = this.zhiying?this.zhiying:null //必须

                    this.confirmBtn = false //成功关闭该提交开关
                    this.$toast('修改成功')
                    setTimeout(() => {

                        this.$router.push({path:'/pending-order'})

                    }, 500)

                    this.loadingShow = false //关闭loading

                }else if(obj.success == false){
                    this.$toast(obj.msg)
                    this.changeorder = false //订单修改开关关闭
                    this.zhisun = this.zhisun?this.zhisun:null //必须
                    this.zhiying = this.zhiying?this.zhiying:null //必须

                    this.confirmBtn = false //失败关闭该提交开关
                    this.loadingShow = false //关闭loading
                }

            }

            // 撤销挂单信息处理
            if(this.Chedan){

                if(obj.success){
                    this.loadingShow = false //关闭提示
                    this.Chedan = false //撤单开关关闭
                    this.$router.push({path:'/pending-order'})
                    this.$toast('撤单成功')
                }else{
                    this.loadingShow = false //关闭提示
                    this.Chedan = false //撤单开关关闭
                    this.reload() //刷新当前页
                    this.$toast(obj.msg)
                }
            }
            
            // 全局订单推送
            if(obj.act == 'order_update'){

                if(this.$store.state.login){

                    this.$store.state.ordertipshow = true
                    
                    this.$store.state.ordertype = obj.msg.replace(/[0-9]/g,"")


                    this.$store.state.orderticket = obj.msg.replace(/[^\d.]/g,"");
                    this.$store.state.ordersymbol = obj.data.symbol
                    this.$store.state.orderdeal = obj.data.orderDirection
                    this.$store.state.orderopenprice = obj.data.openPrice
                    this.$store.state.ordercloseprice = obj.data.closePrice
                    this.$store.state.orderlots = obj.data.lots
                    this.$store.state.orderopentime = obj.data.openTime
                    this.$store.state.orderclosetime = obj.data.closeTime


                    setTimeout(() => {

                        this.$store.state.ordertipshow = false


                    }, 5000)
                }
            }

        },

        // 确认修改
        confirmRevise(){

            if(!this.reviseNum){
                this.$toast('挂单价格不能为空')
                return false;
            }else if(this.reviseNum == 0){
                this.$toast('请输入正确的挂单价格')
                return false;
            }

            this.zhisun = this.zhisun == null?0:this.zhisun //止损价
            this.zhiying = this.zhiying == null?0:this.zhiying //止盈价

            this.changgezhisun = this.changgezhisun == null?0:this.changgezhisun //点数止损价
            this.changgezhiying = this.changgezhiying ==null?0:this.changgezhiying //点数止盈价

            this.tsnum = this.tsnum == null?0:this.tsnum //停损限价

            // this.$store.state.expiration = this.$store.state.expiration  == 0?null:this.$store.state.expiration //时间

            this.reviseNum = this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD'?parseFloat(this.reviseNum).toFixed(2):parseFloat(this.reviseNum).toFixed(3) //挂单价格

            this.$store.state.stopLoss = this.$store.state.stopLoss !==0 && (this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD')?parseFloat(this.$store.state.stopLoss).toFixed(2):parseFloat(this.$store.state.stopLoss).toFixed(3) //上面的止损价
            this.$store.state.takeProfit = this.$store.state.takeProfit !==0 && (this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD')?parseFloat(this.$store.state.takeProfit).toFixed(2):parseFloat(this.$store.state.takeProfit).toFixed(3) //上面的止盈价


            if(this.jiage){

                if(this.reviseNum == this.$store.state.openPrice && this.$store.state.expiration == this.getdatetime && this.zhisun == this.$store.state.stopLoss && this.zhiying == this.$store.state.takeProfit && this.tsnum == this.$store.state.stopLimit){
                    this.$toast('订单没有任何修改')
                    this.zhisun = this.zhisun?this.zhisun:null
                    this.zhiying = this.zhiying?this.zhiying:null

                    return false;
                }

            }else if(this.ds){
                if(this.reviseNum == this.$store.state.openPrice && this.$store.state.expiration == this.getdatetime && this.changgezhisun == this.$store.state.stopLoss && this.changgezhiying == this.$store.state.takeProfit && this.tsnum == this.$store.state.stopLimit){
                    this.$toast('订单没有任何修改')
                    this.changgezhisun = this.changgezhisun?this.changgezhisun:null
                    this.changgezhiying = this.changgezhiying?this.changgezhiying:null

                    return false;
                }
            }
            
            var that = this
            that.global.ws.onmessage = this.onmessage
            that.confirmBtn = true
            that.changeorder = true //订单修改了

            if (that.global.ws && that.global.ws.readyState == 1 && that.confirmBtn) {
                if(that.getisgold){


                    reviseOrder(that.$store.state.ticket,that.reviseNum,that.zhisun?that.zhisun:(that.changgezhisun?that.changgezhisun:null),that.zhiying?that.zhiying:(that.changgezhiying?that.changgezhiying:null),that.getdatetime,that.global.ws,that.changeorder,that.tsnum)

                    // moment().endOf('month').format('YYYY-MM-DD HH:mm:ss') 如需返回具体时间
                }else if(!that.getisgold){


                    
                    reviseOrder(that.$store.state.ticket,that.reviseNum,that.zhisun?that.zhisun:(that.changgezhisun?that.changgezhisun:null),that.zhiying?that.zhiying:(that.changgezhiying?that.changgezhiying:null),that.getdatetime,that.global.ws,that.changeorder,that.tsnum)
                    
                    
                }
            }

            this.loadingShow = true //打开loading

        },

    },

    watch:{

        "newprice"(val){
            if(this.getisgold){
                if(this.$store.state.orderDirection == 2){
                    // 买入市价-$2.00
                    this.gdprice = '<' + (Number(val - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 3){
                    // 卖出市价+$2.00
                    this.gdprice =  '>' + (Number(val + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 4){
                    // 买入市价+$2.00
                    this.gdprice =  '>' + (Number(val + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 5){
                    // 卖出市价-$2.00
                    this.gdprice =  '<' + (Number(val - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }else if(this.$store.state.orderDirection == 6){
                    this.gdprice = ">" + (Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2)
                }else if(this.$store.state.orderDirection == 7){
                    this.gdprice = "<" + (Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2)
                }
            }else if(!this.getisgold){
                if(val && this.$store.state.orderDirection == 2){
                    this.gdprice = '<' + (Number(this.Sub(val,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(val && this.$store.state.orderDirection == 3){
                    this.gdprice = '>' + (Number(this.NumberAdd(val,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(val && this.$store.state.orderDirection == 4){
                    this.gdprice = '>' + (Number(this.NumberAdd(val,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(val && this.$store.state.orderDirection == 5){
                    this.gdprice = '<' + (Number(this.Sub(val,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(this.$store.state.orderDirection == 6){
                    this.gdprice = ">" + (Number(val) + (this.$store.state.silverstopsLevel * 0.001)).toFixed(3)
                }else if(this.$store.state.orderDirection == 7){
                    this.gdprice = "<" + (Number(val) - (this.$store.state.silverstopsLevel * 0.001)).toFixed(3)
                }
            }
        },

        "tsnum"(val){
            if(this.getisgold){

                if(this.$store.state.orderDirection == 6){

                    this.gdzhisun = "<" + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = ">" + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))

                }else if(this.$store.state.orderDirection == 7){
                    this.gdzhisun = ">" + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = "<" + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                }
            }else if(!this.getisgold){
                if(val && this.$store.state.orderDirection == 6){
                    this.slgdzhisun = "<" + (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = ">" + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(val && this.$store.state.orderDirection == 7){
                    this.slgdzhisun = ">" + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = "<" + (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }
            }

        },

        'reviseNum'(val){
            if(this.getisgold){

                if(this.$store.state.orderDirection == 2){

                    this.gdzhisun = '<' + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = '>' + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))

                }else if(this.$store.state.orderDirection == 3){
                
                    this.gdzhisun = '>' + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = '<'+ (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))

                }else if(this.$store.state.orderDirection == 4){
                    
                    this.gdzhisun = '<' + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = '>' + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))

                }else if(this.$store.state.orderDirection == 5){

                    this.gdzhisun = '>' + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    this.gdzhiying = '<' + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))

                }else if(this.$store.state.orderDirection == 6){
                    if(Number(val)){
                        this.gdzhisun = '<' + (Number(Number(this.tsnum) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                        this.gdzhiying = '>' + (Number(Number(this.tsnum) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                        this.tsprice = "<" + (Number(Number(val) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    }else{
                        this.tsprice = null
                    }
                }else if(this.$store.state.orderDirection == 7){
                    if(Number(val)){
                        this.gdzhisun = '>' + (Number(Number(this.tsnum) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                        this.gdzhiying = '<'+ (Number(Number(this.tsnum) - (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                        this.tsprice = ">" + (Number(Number(val) + (this.$store.state.goldstopsLevel * 0.01)).toFixed(2))
                    }else{
                        this.tsprice = null
                    }
                }
            }else if(!this.getisgold){
                if(val && this.$store.state.orderDirection == 2){
                    this.slgdzhisun = '<' + (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = '>'+ (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                }else if(val && this.$store.state.orderDirection == 3){
                    this.slgdzhisun = '>' + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = '<'+ (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))

                }else if(val && this.$store.state.orderDirection == 4){
                    this.slgdzhisun = '<' + (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = '>' + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))

                }else if(val && this.$store.state.orderDirection == 5){
                    this.slgdzhisun = '>' + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    this.slgdzhiying = '<' + (Number(this.Sub(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))

                }else if(val && this.$store.state.orderDirection == 6){
                    if(Number(val)){
                        this.slgdzhisun = '<' + (Number(this.Sub(Number(this.tsnum),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                        this.slgdzhiying = '>'+ (Number(this.NumberAdd(Number(this.tsnum),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                        this.tsprice = "<"  + (Number(this.Sub(val,(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    }else{
                        this.tsprice = null
                    }
                }else if(val && this.$store.state.orderDirection == 7){
                    if(Number(val)){
                        this.slgdzhisun = '>' + (Number(this.NumberAdd(Number(this.tsnum),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                        this.slgdzhiying = '<'+ (Number(this.Sub(Number(this.tsnum),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                        this.tsprice = ">"  + (Number(this.NumberAdd(Number(val),(this.$store.state.silverstopsLevel * 0.001))).toFixed(3))
                    }else{
                        this.tsprice = null
                    }
                }
            }
        },

        'datetext'(val){
            if(val == '本日有效'){
                val = moment().endOf('day').format('X')
            }else if(val == '本周有效'){
                val = moment().endOf('week').format('X')
            }else if(val == '本月有效'){
                val = moment().endOf('month').format('X')
            }
        },

        // 止盈止损点数转换成止盈止损价
        'zhisundianshu'(val){
            if(this.getisgold){
                if(val){
                    if(this.$store.state.orderDirection == 2){
                        this.changgezhisun = this.Sub(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 3){
                        this.changgezhisun = this.NumberAdd(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 4){
                        this.changgezhisun = this.Sub(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 5){
                        this.changgezhisun = this.NumberAdd(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 6){
                        this.changgezhisun = this.Sub(this.tsnum,(val / 100))
                    }else if(this.$store.state.orderDirection == 7){
                        this.changgezhisun = this.NumberAdd(this.tsnum,(val / 100))
                    }
                }else{
                    this.changgezhisun = null
                }
            }else if(!this.getisgold){
                if(val){
                    if(this.$store.state.orderDirection == 2){
                        this.changgezhisun = this.Sub(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 3){
                        this.changgezhisun = this.NumberAdd(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 4){
                        this.changgezhisun = this.Sub(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 5){
                        this.changgezhisun = this.NumberAdd(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 6){
                        this.changgezhisun = this.Sub(this.tsnum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 7){
                        this.changgezhisun = this.NumberAdd(this.tsnum,(val / 1000))
                    }
                }else{
                    this.changgezhisun = null
                }
            }
        },

        //止盈止损点数转换成止盈止损价
        'zhiyingdianshu'(val){
            if(this.getisgold){
                if(val){
                    if(this.$store.state.orderDirection == 2){
                        this.changgezhiying = this.NumberAdd(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 3){
                        this.changgezhiying = this.Sub(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 4){
                        this.changgezhiying = this.NumberAdd(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 5){
                        this.changgezhiying = this.Sub(this.reviseNum,(val / 100))
                    }else if(this.$store.state.orderDirection == 6){
                        this.changgezhiying = this.NumberAdd(this.tsnum,(val / 100))
                    }else if(this.$store.state.orderDirection == 7){
                        this.changgezhiying = this.Sub(this.tsnum,(val / 100))
                    }
                }else{
                    this.changgezhiying = null
                }
            }else if(!this.getisgold){
                if(val){
                    if(this.$store.state.orderDirection == 2){
                        this.changgezhiying = this.NumberAdd(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 3){
                        this.changgezhiying = this.Sub(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 4){
                        this.changgezhiying = this.NumberAdd(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 5){
                        this.changgezhiying = this.Sub(this.reviseNum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 6){
                        this.changgezhiying = this.NumberAdd(this.tsnum,(val / 1000))
                    }else if(this.$store.state.orderDirection == 7){
                        this.changgezhiying = this.Sub(this.tsnum,(val / 1000))
                    }
                }else{
                    this.changgezhiying = null   
                }
            }
        }

    },

    computed:{

        newprice(){
            if(this.$store.state.symbol == "XAU" || this.$store.state.symbol == "GOLD"){
                if(this.$store.state.orderDirection == 2 || this.$store.state.orderDirection == 4 || this.$store.state.orderDirection == 6){
                    return this.$store.state.goldBuy.toFixed(2)
                }else if(this.$store.state.orderDirection == 3 || this.$store.state.orderDirection == 5 || this.$store.state.orderDirection == 7){
                    return this.$store.state.goldSell.toFixed(2)
                }
            }else{
                if(this.$store.state.orderDirection == 2 || this.$store.state.orderDirection == 4 || this.$store.state.orderDirection == 6){
                    return this.$store.state.silverBuy.toFixed(3)
                }else if(this.$store.state.orderDirection == 3 || this.$store.state.orderDirection == 5 || this.$store.state.orderDirection == 7){
                    return this.$store.state.silverSell.toFixed(3)
                }
            }
        },

        // 计算黄金止损预计 
        comtotalzhisun(){
            if(this.$store.state.orderDirection == 2){
                return '预计 ' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 3){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 4){
                return '预计 ' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 5){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 6){
                return '预计' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 7){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*100).toFixed(2)
            }
        },

        // 计算黄金止盈预计 
        comtotalzhiying(){
            if(this.$store.state.orderDirection == 2){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 3){
                return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 4){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 5){
                return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 6){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
            }else if(this.$store.state.orderDirection == 7){
                return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*100).toFixed(2)
            }
        },

        // 计算白银止损预计 
        slcomtotalzhisun(){
            if(this.$store.state.orderDirection == 2){
                return '预计 ' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 3){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 4){
                return '预计 ' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 5){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 6){
                return '预计 ' + (((this.zhisun - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 7){
                return '预计 ' + (((this.reviseNum - this.zhisun)*this.$store.state.lots)*5000).toFixed(2)
            }
        },

        // 计算白银止盈预计 
        slcomtotalzhiying(){
            if(this.$store.state.orderDirection == 2){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 3){
                return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 4){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 5){
                return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 6){
                return '预计 ' + (((this.zhiying - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
            }else if(this.$store.state.orderDirection == 7){
                 return '预计 ' + (((this.reviseNum - this.zhiying)*this.$store.state.lots)*5000).toFixed(2)
            }
        },

        // 计算止损点数换算成价格
        getprice(){
            if(this.getisgold){ //黄金止损
                if(this.$store.state.orderDirection == 2){
                    return this.Sub(this.reviseNum,(this.zhisundianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 3){
                    return this.NumberAdd(this.reviseNum,(this.zhisundianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 4){
                    return this.Sub(this.reviseNum,(this.zhisundianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 5){
                    return this.NumberAdd(this.reviseNum,(this.zhisundianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 6){
                    return this.Sub(this.tsnum,(this.zhisundianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 7){
                    return this.NumberAdd(this.tsnum,(this.zhisundianshu / 100).toFixed(2))
                }
            }else if(!this.getisgold){ //白银止损
                if(this.$store.state.orderDirection == 2){

                    return this.Sub(this.reviseNum,(this.zhisundianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 3){

                    return this.NumberAdd(this.reviseNum,(this.zhisundianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 4){

                    return this.Sub(this.reviseNum,(this.zhisundianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 5){

                    return this.NumberAdd(this.reviseNum,(this.zhisundianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 6){

                    return this.Sub(this.tsnum,(this.zhisundianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 7){

                    return this.NumberAdd(this.tsnum,(this.zhisundianshu / 1000).toFixed(3)) 

                }
            }
        },

        // 计算止盈点数换算成价格
        getpricezy(){
            if(this.getisgold){ //黄金止盈
                if(this.$store.state.orderDirection == 2){
                   return  this.NumberAdd(this.reviseNum,(this.zhiyingdianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 3){
                   return  this.Sub(this.reviseNum,(this.zhiyingdianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 4){
                   return  this.NumberAdd(this.reviseNum,(this.zhiyingdianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 5){
                   return  this.Sub(this.reviseNum,(this.zhiyingdianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 6){
                   return  this.NumberAdd(this.tsnum,(this.zhiyingdianshu / 100).toFixed(2))
                }else if(this.$store.state.orderDirection == 7){
                   return  this.Sub(this.tsnum,(this.zhiyingdianshu / 100).toFixed(2))
                }
            }else if(!this.getisgold){ //白银止盈
                if(this.$store.state.orderDirection == 2){

                    return this.NumberAdd(this.reviseNum,(this.zhiyingdianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 3){

                   return this.Sub(this.reviseNum,(this.zhiyingdianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 4){

                    return this.NumberAdd(this.reviseNum,(this.zhiyingdianshu / 1000).toFixed(3)) 

                }else if(this.$store.state.orderDirection == 5){

                    return this.Sub(this.reviseNum,(this.zhiyingdianshu / 1000).toFixed(3)) 
                    
                }else if(this.$store.state.orderDirection == 6){

                    return this.NumberAdd(this.tsnum,(this.zhiyingdianshu / 1000).toFixed(3)) 
                    
                }else if(this.$store.state.orderDirection == 7){

                    return this.Sub(this.tsnum,(this.zhiyingdianshu / 1000).toFixed(3)) 
                    
                }
            }
        },

        // 计算点数止损预计
        getdszhisun(){
            if(this.getisgold){

                if(this.$store.state.orderDirection == 2){
                    
                    return '预计' + (((this.getprice - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 3){

                    return '预计' + (((this.reviseNum - this.getprice)*this.$store.state.lots)*100).toFixed(2)

                }else if(this.$store.state.orderDirection == 4){

                    return '预计' + (((this.getprice - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)

                }else if(this.$store.state.orderDirection == 5){

                    return '预计' + (((this.reviseNum - this.getprice)*this.$store.state.lots)*100).toFixed(2)

                }else if(this.$store.state.orderDirection == 6){

                    return '预计' + (((this.getprice - this.tsnum)*this.$store.state.lots)*100).toFixed(2)

                }else if(this.$store.state.orderDirection == 7){

                    return '预计' + (((this.tsnum - this.getprice)*this.$store.state.lots)*100).toFixed(2)

                }
            }else if(!this.getisgold){
                if(this.$store.state.orderDirection == 2){

                    return '预计' + (((this.getprice - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)

                }else if(this.$store.state.orderDirection == 3){

                    return '预计' + (((this.reviseNum - this.getprice)*this.$store.state.lots)*5000).toFixed(2)

                }else if(this.$store.state.orderDirection == 4){

                    return '预计' + (((this.getprice - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)

                }else if(this.$store.state.orderDirection == 5){

                    return '预计' + (((this.reviseNum - this.getprice)*this.$store.state.lots)*5000).toFixed(2)

                }else if(this.$store.state.orderDirection == 6){

                    return '预计' + (((this.getprice - this.tsnum)*this.$store.state.lots)*5000).toFixed(2)

                }else if(this.$store.state.orderDirection == 7){

                    return '预计' + (((this.tsnum - this.getprice)*this.$store.state.lots)*5000).toFixed(2)

                }
            }
        },

        // 计算点数止盈预计

        getdszhiying(){
            if(this.getisgold){
                if(this.$store.state.orderDirection == 2){
                    return '预计' + (((this.getpricezy - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 3){
                    return '预计' + (((this.reviseNum - this.getpricezy)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 4){
                    return '预计' + (((this.getpricezy - this.reviseNum)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 5){
                    return '预计' + (((this.reviseNum - this.getpricezy)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 6){
                    return '预计' + (((this.getpricezy - this.tsnum)*this.$store.state.lots)*100).toFixed(2)
                }else if(this.$store.state.orderDirection == 7){
                    return '预计' + (((this.tsnum - this.getpricezy)*this.$store.state.lots)*100).toFixed(2)
                }
            }else if(!this.getisgold){
                if(this.$store.state.orderDirection == 2){
                    return '预计' + (((this.getpricezy - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
                }else if(this.$store.state.orderDirection == 3){
                    return '预计' + (((this.reviseNum - this.getpricezy)*this.$store.state.lots)*5000).toFixed(2)
                }else if(this.$store.state.orderDirection == 4){
                    return '预计' + (((this.getpricezy - this.reviseNum)*this.$store.state.lots)*5000).toFixed(2)
                }else if(this.$store.state.orderDirection == 5){
                    return '预计' + (((this.reviseNum - this.getpricezy)*this.$store.state.lots)*5000).toFixed(2)
                }else if(this.$store.state.orderDirection == 6){
                    return '预计' + (((this.getpricezy - this.tsnum)*this.$store.state.lots)*5000).toFixed(2)
                }else if(this.$store.state.orderDirection == 7){
                    return '预计' + (((this.tsnum - this.getpricezy)*this.$store.state.lots)*5000).toFixed(2)
                }
            }
        },

        // 计算时间
        getdatetime(){

            if(this.datetext == '本日有效'){
                return moment().endOf('day').format('X')
            }else if(this.datetext == '本周有效'){
                return moment().endOf('week').format('X')
            }else if(this.datetext == '本月有效'){
                return moment().endOf('month').format('X')
            }else if(this.datetext == '长期有效'){
                return 0
            }else if(this.datetext == null){
                return this.$store.state.expiration
            }else{
                return Number(moment(this.dealdatetext).format("X"))
            }
        }

    },
    beforeDestroy() {
        this.$router.push({path:'/pending-order'})
    },
    mounted(){
        this.initWebpack() //开启ws
        this.getisgold = this.$store.state.getisgold //判断是否黄金



        // 设置初始价格
        this.reviseNum = this.$store.state.symbol == 'XAU' || this.$store.state.symbol == 'GOLD'?parseFloat(this.$store.state.openPrice).toFixed(2):parseFloat(this.$store.state.openPrice).toFixed(3)

        // 设置止损价
        this.zhisun = this.$store.state.stopLoss == '0.00' || this.$store.state.stopLoss == '0.000' ?null:this.$store.state.stopLoss
        this.zhiying = this.$store.state.takeProfit == '0.00' || this.$store.state.takeProfit == '0.000' ?null:this.$store.state.takeProfit

    },

}
</script>

<style scoped>
    body{touch-action: none}
    .mask{background: #000000;width: 100%;height: 100%;opacity: 0.5;position: fixed;left: 0;top: 0;z-index: 887;}
    .list-item{background-color: #FFFFFF;border-radius: 12px;margin-top: 10px;}
    .list-item .title{padding: 12px 12px 0 12px;display: flex;align-items: center;}
    .list-item .title span:nth-of-type(1){padding: 3.33px 6.67px; height: 18px;border-radius: 12px;background-color: #17CF84;display: flex;justify-content: center;align-items: center;color: #FFFFFF;font-size: 12px;}
    .list-item .title span:nth-of-type(2){color: #333333;font-size: 16px;font-weight: bold;padding-left: 6px;}
    .list-item .title span:nth-of-type(3){color: #BBBBBB;font-size: 12px;text-align: right;flex: 1;text-align: right;}
    .list-item ul{padding: 0 12px 19.33px 12px; display: flex;justify-content: flex-start;align-items: center;flex-wrap: wrap;position: relative;}
    .list-item ul li{display: flex;flex-wrap: wrap;}
    .list-item ul li p{padding-top: 12px;}
    .list-item ul li .left{color: #999999;font-size: 14px;}
    .list-item ul li .right{padding-left: 15px;color: #999999;font-size: 14px;}
    .list-item ul li .left span{padding-left: 8.67px;color: #333333;font-size: 14px;}
    .list-item ul li .right span{padding-left: 8.67px;color: #333333;font-size: 14px;}

    .revise{width: 100%;height: 1000px;position: fixed;top: 0;left: 0;z-index: 885;background-color: #F5F5F5;}
    .revise .title{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;}
    .revise .title img{width: 24px;height: 24px;display: block;}
    .revise .title p:nth-of-type(1){font-size: 16px;color: #333333;font-weight: bold;}
    .revise .title p:nth-of-type(2){font-size: 14px;color: #333333;}

    .revise-content{background-color: #FFFFFF;}
    .revise-content .tips{padding: 17px 0 7.33px 15px;color: #BBBBBB;font-size: 12px;}

    .revise-item{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .revise-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .revise-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .revise-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .revise-item p:nth-of-type(2) span{color: #999999;font-size: 14px;}
    .revise-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}
    .cut{width: 22px;height: 22px;display: block;margin-right: 10px;}
    .add{width: 22px;height: 22px;display: block;margin-left: 10px;}
    input{text-align: center;width: 34%;outline: none;border: none;}

    .revise-item .price-up{width: 16px;height: 16px;display: block;margin-left: 12.67px;transition: all 0.5s;}
    .revise-item .jiage{width: 50px;height: 20px;font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-left-radius: 11px;border-bottom-left-radius: 11px;border-top-right-radius: 0;border-bottom-right-radius: 0;}
    .revise-item .dianshu{width: 50px;height: 20px; font-size: 12px !important;display: flex;justify-content: center;align-items: center;border-top-right-radius: 11px;border-bottom-right-radius: 11px;border-top-left-radius: 0;border-bottom-left-radius: 0;}

    .sliderdown-item{height: 44px;padding: 0 15px;display: flex;justify-content: space-between;align-items: center;border-bottom: 1px solid #EEEEEE;}
    .sliderdown-item p:nth-of-type(1){color: #333333;font-size: 14px;display: flex;align-items: center;justify-content: flex-start;flex: 1;}
    .sliderdown-item p:nth-of-type(1) span{color: #999999;font-size: 12px;padding-left: 8.33px;}
    .sliderdown-item p:nth-of-type(2){color: #333333;font-size: 14px;font-weight: bold;display: flex;align-items: center;text-align: right;flex: 1;justify-content: flex-end;}
    .sliderdown-item p:nth-of-type(2) span{color: #999999;font-size: 14px;padding-left: 5px;}
    .sliderdown-item p:nth-of-type(2) .icon-right{width: 16px;height: 16px;display: block;}

    .active{display: block;width: 36px;height: 22px;border-radius: 9px;color: #FF4F36 !important; text-align: center;line-height: 18px;border: none;background-color: #FFEDEA !important;}
    .actived{display: block;width: 36px;height: 20px;border-radius: 9px;text-align: center;line-height: 18px;}
    
    /* 修改撤单按钮 */
    .reviseBtn{padding: 15px 15px 270px 15px;display: flex;justify-content: space-between;align-items: center;}
    .reviseBtn p:nth-of-type(1){width: 48.3%;height: 44px;color: #333333;font-size: 16px;border-radius: 22px;background-color: #EEEEEE;text-align: center;line-height: 44px;font-weight: bold;}
    .reviseBtn p:nth-of-type(2){width: 48.3%;height: 44px;color: #FFFFFF;font-size: 16px;border-radius: 22px;background-image: linear-gradient(to right, #FF4F36,#FF6738);text-align: center;line-height: 44px;font-weight: bold;}

    /* 选择交易日期 */
    .databox{border-top-left-radius: 12px;border-top-right-radius: 12px;background-color: #FFFFFF;position: fixed;left: 0;right: 0;bottom: 0;z-index: 9999999999999999999;padding-bottom: 30px;}
    .databox .title{text-align: center;padding: 17px 0;font-weight: bold;}
    .databox .title .close{width: 24px;height: 24px;display: block;position: absolute;left: 15.33px;top: 13px;}
    .databox .datelist{padding-left: 20.33px}
    .databox .datelist .item{border-bottom: 1px solid #F5F5F5;height: 45px;display: flex;justify-content: space-between;align-items: center;color: #333333;font-size: 16px;}
    .databox .datelist .item img{width: 24px;height: 24px;display: block;margin-right: 15px;}

    /* timepicer */
    .timebox{background-color: #FFFFFF;position: fixed;bottom: 0;width: 100%;z-index: 99999;border-top-left-radius:12px;border-top-right-radius: 12px;}
    .timeboxwrapper{padding: 0 32px;background-color: #FFFFFF;margin-top: 10px;}
    .timeboxwrapper .title{color: #333333;font-weight: bold;font-size: 16px;text-align: center;padding: 17.67px 0 32px 0;}
    .timebox ul{display: flex;}
    .timebox ul li{padding: 0 4px;flex: 1;display: flex;justify-content: center;color:#BBBBBB;font-size: 16px;}
    .timebtn{padding: 0 20px; margin:0 auto;display: flex;justify-content: space-between;align-items: center;margin-top: 25px;margin-bottom: 40px;}
    .timebtn p:nth-of-type(1){width: 48.3%;height: 44px;font-weight: bold;color: #333333;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-color: #EEEEEE;}
    .timebtn p:nth-of-type(2){width: 48.3%;height: 44px;font-weight: bold;color: #FFFFFF;font-size: 16px;display: flex;justify-content: center;align-items: center;border-radius: 22px;background-image: linear-gradient(to bottom, #FF6738, #FF4F36);}

    /* 加载loading */
    .isloginTips{width: 150px;border-radius: 9px;background: rgba(0, 0, 0, 0.6);position: fixed;left: 0;right: 0;top: 40%;z-index: 888;color: #FFFFFF;font-weight: bold;font-size: 14px;text-align: center;line-height: 60px;margin: 0 auto;display: flex;justify-content: center;align-items: center;flex-direction: column;}
    .isloginTips p{height: 50px;display: flex;align-items: center;}
    .isloginTips img{width: 40px;height: 40px;display: block;margin-top: 20px;animation:loading 0.75s linear infinite forwards;}
    @keyframes loading {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
</style>




// WEBPACK FOOTER //
// src/components/revisepage.vue